import React from 'react';
import DashboardCard from '../shared/DashboardCard';
import EmptyState from '../shared/EmptyState';
import styles from '../../../../styles/DashboardV2.module.css';

interface ActivityItem {
    id: string;
    text: string;
    createdAt: string;
    type?: string;
}

interface RecentActivityWidgetProps {
    activities: ActivityItem[];
    loading?: boolean;
}

const getTimeAgo = (dateStr: string): string => {
    const now = new Date();
    const then = new Date(dateStr);
    const diffMs = now.getTime() - then.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffMins < 1)   return 'Just now';
    if (diffMins < 60)  return `${diffMins} minute${diffMins !== 1 ? 's' : ''} ago`;
    if (diffHours < 24) return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7)   return `${diffDays} days ago`;
    return then.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
};

const RecentActivityWidget: React.FC<RecentActivityWidgetProps> = ({
    activities,
    loading,
}) => {
    const top10 = activities.slice(0, 10);

    return (
        <DashboardCard
            title="Recent Activity"
            loading={loading}
        >
            {top10.length === 0 ? (
                <EmptyState icon="📝" message="No recent activity." />
            ) : (
                <div className={styles.activityFeed}>
                    {top10.map(item => (
                        <div key={item.id} className={styles.activityItem}>
                            <div className={styles.activityDot} />
                            <div className={styles.activityContent}>
                                <div className={styles.activityText}>{item.text}</div>
                                <div className={styles.activityTime}>{getTimeAgo(item.createdAt)}</div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </DashboardCard>
    );
};

export default RecentActivityWidget;
